/* eslint-disable @typescript-eslint/no-unused-vars */
import { createReducer, on } from '@ngrx/store';
import { EntryStoreState } from './entry.model';
import { EntryActions } from './entry.actions';
import { ClusterData, EntryData, ProviderData } from '../entry/structure-data.models';

export const ENTRY_STORE_STATE_KEY = 'entry';

const initialState: EntryStoreState = {
  accession: '',
  uniprotAccession: '',
  isUniProt: undefined,
  entryData: {} as EntryData,
  csvAmData: undefined,
  tedDomainData: [],
  llmAnnotationsData: undefined,
  llmAnnotationsLoaded: false,
  clustermmseqData: {} as ClusterData,
  clusterfoldseekData: {} as ClusterData,
  uniprotData: {},
  providerData: {} as ProviderData,
  complexData: undefined,
  complexDataList: [],
  macromoleculesData: [],
};

export const entryReducer = createReducer(
  initialState,
  on(EntryActions.setCurrentAccession, (state, action) => ({
    ...state,
    accession: action.accession,
    llmAnnotationsData: undefined,
    llmAnnotationsLoaded: false,
    complexData: undefined,
    complexDataList: [],
  })),
  on(EntryActions.setCurrentUniprotAccession, (state, action) => ({
    ...state,
    uniprotAccession: action.uniprotAccession,
  })),
  on(EntryActions.setCurrentIsUniprot, (state, action) => ({
    ...state,
    IsUniProt: action.isUniProt,
  })),
  on(EntryActions.setCurrentProvider, (state, action) => ({
    ...state,
    providerData: action.providerData,
  })),
  on(EntryActions.getEntryDataSuccess, (state, action) => ({
    ...state,
    entryData: action.entryData,
    macromoleculesData: action.macromoleculesData,
  })),
  on(EntryActions.getCSVDataSuccess, (state, action) => ({
    ...state,
    csvAmData: action.csvAmData,
  })),
  on(EntryActions.getTedDomainDataSuccess, (state, action) => ({
    ...state,
    tedDomainData: action.tedDomainData,
  })),
  on(EntryActions.getLlmAnnotationsDataSuccess, (state, action) => ({
    ...state,
    llmAnnotationsData: action.llmAnnotationsData,
    llmAnnotationsLoaded: true,
  })),
  // Record a failed fetch as "no annotations" for that accession, so the tab doesn't keep waiting
  // for data that will never arrive (e.g. a heterodimer chain whose request errored).
  on(EntryActions.getLlmAnnotationsDataFailure, (state, action) => ({
    ...state,
    llmAnnotationsData: action.uniprotAccession
      ? { dataType: 'ANNOTATIONS', data: [], uniprotAccession: action.uniprotAccession }
      : state.llmAnnotationsData,
    llmAnnotationsLoaded: true,
  })),
  on(EntryActions.getClustermmseqSuccess, (state, action) => ({
    ...state,
    clustermmseqData: action.clustermmseqData,
  })),
  on(EntryActions.getClusterfoldseekSuccess, (state, action) => ({
    ...state,
    clusterfoldseekData: action.clusterfoldseekData,
  })),
  on(EntryActions.getUniprotDataSuccess, (state, action) => ({
    ...state,
    uniprotData: action.uniprotData,
  })),
  on(EntryActions.getComplexDataSuccess, (state, action) => ({
    ...state,
    complexData: action.complexData,
    complexDataList: action.complexDataList,
  })),
);
